import React from 'react'
import './shop.css'

const Shop = () => {
  return (
    <div>Shop</div>
  )
}

export default Shop